import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    Connection,
    PositionsConnectionsSliceSchema,
} from '../../../model/types/positionsConnectionsSliceSchema';

const initialState: PositionsConnectionsSliceSchema = {
    connections: [],
};

const positionsConnectionsSlice = createSlice({
    name: 'positionsConnections',
    initialState,
    reducers: {
        setConnections: (state, { payload }: PayloadAction<Connection[]>) => {
            state.connections = payload;
        },
        addConnection: (state, { payload }: PayloadAction<Connection>) => {
            state.connections = [...state.connections, payload];
        },
        addConnections: (state, { payload }: PayloadAction<Connection[]>) => {
            state.connections = [...state.connections, ...payload];
        },
        deleteConnection: (state, { payload }) => {
            state.connections = state.connections.filter((connection) => connection !== payload);
        },
    },
});

export const { actions: positionsConnectionsActions } = positionsConnectionsSlice;
export const { reducer: positionsConnectionsReducer } = positionsConnectionsSlice;
